import callApi from '../../utils/api';
import { API_BASE_URL } from '../../utils/constants';
import { IR_COURSE_MAPPING } from '../quiz/quizBaseApi';

const apiPost = callApi(API_BASE_URL || "");
const LOGIN_PATH = "/v1/api/user/authenticate";
const CHANGE_PASSWORD = "/passwords/change_password";
const FORGOT_PASSWORD = '/passwords/forgot';
const RESET_PASSWORD = '/passwords/reset';
const DETAIL = '/auth/me'

const login = async (payload) => apiPost.post(LOGIN_PATH, payload, "");
const changePassword = async (payload) => apiPost.put(CHANGE_PASSWORD, payload, "");
const forgotPassword = async (payload) => apiPost.post(FORGOT_PASSWORD, payload, "");
const resetPassword = async (payload) => apiPost.post(RESET_PASSWORD, payload, "");
const getDetail = async () => {
    let detail = localStorage.getItem('user');
    return JSON.parse(detail)
    // return await apiPost.get(DETAIL, "");
}
const loadIrLevelMapping = async () => await callApi().asyncFetchContent(IR_COURSE_MAPPING);

export { login, changePassword, forgotPassword, resetPassword,getDetail, loadIrLevelMapping };
